<template>
  <table class="default-table" :style="custom_style" v-bind="$attrs">
    <slot></slot>
  </table>
</template>

<script lang="ts">
export default {
  props: {
    custom_style: {
      default: '',
      required: false,
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.default-table {
  white-space: nowrap;
  height: 100%;
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
  border: 1px solid #dee2e6;
  flex-grow: 1;
}
.default-table table {
  background-color: #fff;
  height: 50px;
}
</style>
